import Select from 'react-select';

const ThemedSelect = ({ ...props }) => {
    const textColor = getComputedStyle(document.documentElement)
        .getPropertyValue('--text-color')
        .trim();

    return (
        <Select
            {...props}
            theme={(theme) => ({
                ...theme,
                colors: {
                    ...theme.colors,
                    neutral80: textColor,
                },
            })}
        />
    );
}

export default ThemedSelect;